module.exports = __webpack_public_path__ + "static/lich-70fe248ff9117b12f249a80e7310e9f4.png";